export default (ctx, html) => html`${ctx.hide? '' : html`<slot></slot>`}`;
